/**
 * Shared time format helpers for consistent chart labeling.
 */

/**
 * Format elapsed milliseconds as mm:ss (no subseconds).
 */
export function formatElapsedMs(ms: number): string {
  if (!isFinite(ms) || ms < 0) return '';
  const totalSec = Math.floor(ms / 1000);
  const m = Math.floor(totalSec / 60);
  const s = totalSec % 60;
  return `${m}:${s.toString().padStart(2, '0')}`;
}

/**
 * Format elapsed milliseconds as mm:ss or mm:ss.t (tenths) when short.
 * Default shows tenths for durations <= 2 minutes.
 */
export function formatElapsedMsAdaptive(ms: number, tenthsThresholdMs = 120_000): string {
  if (!isFinite(ms) || ms < 0) return '';
  if (ms <= tenthsThresholdMs) {
    const totalSec = ms / 1000;
    const m = Math.floor(totalSec / 60);
    const s = Math.floor(totalSec % 60);
    const t = Math.floor((totalSec % 1) * 10);
    return `${m}:${s.toString().padStart(2, '0')}.${t}`;
  }
  return formatElapsedMs(ms);
}

/**
 * Format elapsed seconds as mm:ss
 */
export function formatElapsedSeconds(seconds: number): string {
  if (!isFinite(seconds) || seconds < 0) return '';
  const total = Math.floor(seconds);
  const m = Math.floor(total / 60);
  const s = total % 60;
  return `${m}:${s.toString().padStart(2, '0')}`;
}
